var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-row',{staticClass:"px-0 mx-0"},[_c('v-icon',[_vm._v(" mdi-home ")]),_c('v-breadcrumbs',{staticClass:"px-2 py-0",attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"divider",fn:function(){return [_c('v-icon',[_vm._v("mdi-chevron-right")])]},proxy:true}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }